import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { firestore } from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  messageForm = new FormGroup({
    name: new FormControl('', Validators.required),
    message: new FormControl('', Validators.required),
    contact: new FormControl('', Validators.required)
  });

  productDB: AngularFireList<any>;
  settingDB: AngularFireList<any>;
  homeDB: AngularFireList<any>;
  aboutDB: AngularFireList<any>;
  galleryDB: AngularFireList<any>;
  contactDB: AngularFireList<any>;
  feedbackDB: AngularFireList<any>;

  constructor(private db: AngularFireDatabase) {
    this.productDB = db.list('products');
    this.settingDB = db.list('setting');
    this.feedbackDB = db.list('feedbacks');
  }

  getProductDB() {
    return this.productDB.snapshotChanges();
  }

  getSettingDB() {
    return this.settingDB.snapshotChanges();
  }

  getHomeDB() {
    this.homeDB = this.db.list('setting/home');
    return this.homeDB.snapshotChanges();
  }

  getAboutDB() {
    this.aboutDB = this.db.list('setting/about');
    return this.aboutDB.snapshotChanges();
  }

  getGalleryDB() {
    this.galleryDB = this.db.list('setting/gallery');
    return this.galleryDB.snapshotChanges();
  }

  getContactDB() {
    this.contactDB = this.db.list('setting/contact');
    return this.contactDB.snapshotChanges();
  }

  sendFeedback(feedback) {
    feedback.timestamp = Date.now();
    this.feedbackDB.push(feedback);
    this.messageForm.reset();
  }
}
